import { navLinks } from '@/mocks/routeData';

export default function Footer() {
  return (
    <footer className="border-t border-orange-100 bg-gradient-to-b from-orange-50 to-amber-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-orange-500 text-lg font-black text-white">瓜</span>
              <span className="flex flex-col leading-none">
                <span className="font-mag text-xl font-black text-stone-900">吃瓜线路</span>
                <span className="mt-0.5 text-[11px] tracking-widest text-stone-400">观看顺序 · 线路整理</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-6 text-stone-500">
              一个社区共建的观剧导航站：持续整理热门作品的观看顺序与推荐路线，把流畅线路与高清线路按体验排好，点开即可顺着看。内容整理自社区讨论，仅供浏览参考，版权归各原片方所有。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['流畅线路', '高清线路', '观看顺序', '推荐路线'].map((k) => (
                <span key={k} className="rounded-full bg-white px-3 py-1 text-xs text-stone-500 ring-1 ring-stone-200">
                  {k}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-stone-900">内容分区</h4>
            <ul className="mt-4 grid grid-cols-1 gap-2.5">
              {navLinks.slice(1).map((l) => (
                <li key={l.key}>
                  <a href={l.href} className="flex items-center gap-2 text-sm text-stone-500 transition hover:text-orange-600">
                    <i className="ri-arrow-right-s-line text-orange-300" /> {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-stone-900">观剧小贴士</h4>
            <ul className="mt-4 space-y-2.5 text-sm leading-6 text-stone-500">
              <li className="flex gap-2"><i className="ri-speed-line mt-0.5 text-teal-500" /> 赶进度用流畅线路，看画面用高清线路。</li>
              <li className="flex gap-2"><i className="ri-list-check-2 mt-0.5 text-orange-500" /> 多部连看先确认观看顺序，减少剧透。</li>
              <li className="flex gap-2"><i className="ri-refresh-line mt-0.5 text-rose-500" /> 线路不稳就多刷新或切换备源。</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-orange-200/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-stone-400">
            © 2026 吃瓜线路 · 观看顺序与推荐路线整理站。本站仅整理信息，不承载任何影音内容。
          </p>
          <p className="text-xs text-stone-400">刷新于 09-07 · 若内容与事实不符，欢迎到社区指正</p>
        </div>
      </div>
    </footer>
  );
}